import { render, staticRenderFns } from "./PointPickerDialog.vue?vue&type=template&id=1a28f4e6&scoped=true&"
import script from "./PointPickerDialog.vue?vue&type=script&lang=js&"
export * from "./PointPickerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a28f4e6",
  null
  
)

export default component.exports